<template>
  <div class="root_QRCode flex-col scaler_QRCode">
    <div class="block_1 flex-row">
      <div class="group_1 flex-col">
        <div class="image-wrapper_1 flex-row">
          <router-link to="/store/dashboard/profile">
            <img class="label_1" style="height:29px;" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG2782f6d9ac2f655cfbb22e2b6cc09020.png" />
          </router-link>
        </div>
        <div class="section_1 flex-row" style="justify-content: center;">
          <div style="text-align: center;">
            <span style="font-size: x-large;font-weight: 700;">绑定微信号</span>
            <br><br><br>
            <span style="font-size: large;">使用微信扫一扫下方二维码</span>
            <br><br>
            <img style="width:250px;height:250px;" referrerpolicy="no-referrer"
              :src="scanImg" />
            <br><br><br>
            <span style="font-size: large;">下次扫码登录更便捷</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {test_bindOa} from '@/api/user';
export default {
  data() {
    return {
      scanImg:require('./assets/img/FigmaDDSSlicePNG73e2f130989e91c0c777758f7c586bf9.png')
    };
  },
  methods: {

  },
  mounted() {
    test_bindOa().then(response => {
      if(response.data.code==200){
        this.scanImg = response.data.data.url;
      }else{
        this.$message({
            message: res.data.msg,
            type: 'error',
          });
      }

    });
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.scaler_QRCode {
  transform-origin: top left;
  transform: scale(0.75);
}
</style>